import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityTecnicosLoadFailure,
  entityTecnicosLoadSuccess,
  entityTecnicosLoadRequest
} from './entity-tecnicos.actions';

import { TecnicosService } from './entity-tecnicos.service';

@Injectable()
export class TecnicosEffects {
  // load
  loadRequestTecnicos = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTecnicosLoadRequest),
      mergeMap(() =>
        this.tecnicosService.getTecnicos().pipe(
          map((items) => entityTecnicosLoadSuccess({ items })),
          catchError((error) => of(entityTecnicosLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private tecnicosService: TecnicosService
  ) {
    this.tecnicosService.url = environment.apiUrl;
  }
}
